import { type ReactNode } from 'react';

export type ChipTemplate = { id: string; label: string; text: string };

type Props = {
  templates: ReadonlyArray<ChipTemplate>;
  current: string;
  onPick: (text: string) => void;
};

// Generic one-tap chip row used by both the collector's appeal textarea
// and the admin's reject-appeal form. Click fills the surrounding input
// with the preset; an active chip (current === template.text) gets a
// red accent so the user knows their input matches a known template.
export function TemplateChips({
  templates,
  current,
  onPick,
}: Props): ReactNode {
  return (
    <div className="flex flex-wrap gap-xs">
      {templates.map((t) => (
        <ChipButton
          key={t.id}
          active={current === t.text}
          label={t.label}
          text={t.text}
          onClick={() => onPick(t.text)}
        />
      ))}
    </div>
  );
}

function ChipButton(p: {
  active: boolean;
  label: string;
  text: string;
  onClick: () => void;
}): ReactNode {
  const cls = p.active
    ? 'border-brand-red bg-brand-red/10 text-brand-red'
    : 'border-white/[0.06] bg-surface-elevated text-text-secondary hover:border-white/[0.12] hover:text-text-primary';
  return (
    <button
      type="button"
      onClick={p.onClick}
      className={`rounded-full border px-sm py-[2px] text-xs transition ${cls}`}
      title={p.text}
    >
      {p.label}
    </button>
  );
}
